import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { UserMaintenanceRoutes } from 'src/app/core/enums/routes.enum';
import { IMaintenanceJobForTable } from 'src/app/maintenance-user/models/maintenance-job.model';
import { TenantUserAccessState } from 'src/app/tenant-selector/state/tenant-user-access.state';
import {
  ReactivateMaintenanceJob,
  RestoreMaintenanceJob,
} from 'src/app/maintenance-user/state/maintenance-job.actions';
import { Privileges } from 'src/app/core/privileges/privileges';

@Component({
  selector: 'app-maintenance-template',
  templateUrl: './maintenance-template.component.html',
  styleUrls: ['./maintenance-template.component.scss'],
  standalone: false,
})
export class MaintenanceTemplateComponent implements OnInit {
  @Input() columnName: string;
  @Input() element: IMaintenanceJobForTable & Record<string, any>;
  @Input() buttonFunctions: { [key: string]: () => void };

  Privileges = Privileges;
  expiryDate: Date;
  performRoute: string;
  marineManagerEnabled = this.store.selectSnapshot(TenantUserAccessState.getMarineManagerEnabled);

  get isProjectExportedActionsDisabled(): boolean {
    return this.marineManagerEnabled && (this.element?.project?.isExported ?? false);
  }

  get performButtonDisabled(): boolean {
    return (
      this.element.isDisabled ||
      (!this.element.canPerform && !this.element.canOpenDraft) ||
      (!this.element.isDraft && this.isProjectExportedActionsDisabled)
    );
  }

  get performButtonTooltip(): string {
    if (!this.element.isDraft && this.isProjectExportedActionsDisabled) {
      return 'projectExportedActionsDisabled';
    }
    if ((!this.element.canPerform && !this.element.canOpenDraft) || this.element.isDisabled) {
      return 'notResponsibleForPerformingJob';
    }
    return '';
  }

  constructor(private store: Store) {}

  ngOnInit(): void {
    if (this.element.expiryType === 'Both' && this.element.dueDateOrRuntime) {
      this.expiryDate = new Date(
        Math.min(
          +new Date(this.element.dueDateOrRuntime.intervalExpiry),
          +new Date(this.element.dueDateOrRuntime.runtimeExpiry.dueDate)
        )
      );
    }
    this.performRoute = UserMaintenanceRoutes.JobPerform.replace(
      ':componentId',
      this.element.menuId
    ).replace(':id', this.element.jobId);
  }

  restore(): void {
    this.store.dispatch(new RestoreMaintenanceJob(this.element.jobId));
  }

  reactivate(): void {
    this.store.dispatch(new ReactivateMaintenanceJob(this.element.jobId));
  }
}
